import React from "react";
import { AiOutlineArrowUp } from "react-icons/ai";
import Loader from "react-loader-spinner";
import { FaSpinner } from 'react-icons/fa';
import { numberWithCommas } from "../../service/utilService";


export default function TransactionBlock(props) {
    const {backgroundColor, label, count, acceptedStatus,rejectedStatus, tracAcceptedCount, tracRejectedCount,showRupee,transDateWise,loader,fractionalDigit} = props;
  return (
    <div>
      <Loader className="loader trans-loader"
      type="ThreeDots"
      color="#9c1d26"
      width={100}
      visible={loader}
      />
      <div className={"transactions-block "+backgroundColor }>
        <p className="tran-block-lable">{label} </p>
        <p className="tran-count">{showRupee && <>&#8377;</>}{numberWithCommas(count || 0, fractionalDigit)}</p>
        <div className="flex-row">
          <div>
            <p className="tran-status">{acceptedStatus} </p>
            <p className="tran-accepted-count">{showRupee && <>&#8377;</>}{numberWithCommas(tracAcceptedCount || 0, fractionalDigit)}</p>
          </div>
          <div>&nbsp;</div>
          <div>
            <p className="tran-status">{rejectedStatus} </p>
            <p className="tran-accepted-count">{showRupee && <>&#8377;</>}{numberWithCommas(tracRejectedCount || 0, fractionalDigit)}</p>
          </div>
        </div>
      </div>
      <div className="flex-row date-wisedata-block">
        {transDateWise.length > 0
          ? transDateWise.map((e) => (
              <TransactionSubBlock
                label={e.date}
                count={showRupee ? e.sumAmount : e.cases}
                percentage={showRupee ? e.amtPer?.value : e.casesPer?.value}
                status={showRupee ? e.amtPer?.status : e.casesPer?.status}
                showRupee={showRupee}
                fractionalDigit={fractionalDigit}
              />
            ))
          : [1,2,3].map((e) => <WaitTransactionSubBlock />)}
      </div>
    </div>
  );
}

const TransactionSubBlock =(props)=>{
const {label,count,percentage,status,showRupee, fractionalDigit} = props;
    return (
        <div className="sub-block">
          <p className="sub-block-lable">{label || '--'}</p>
          <p className="sub-block-count">{showRupee && <>&#8377;</>}{numberWithCommas(count || '0', fractionalDigit)}</p>
          <p className="sub-block-per">{(+(percentage || 0)).toFixed(2) || '0'}%<AiOutlineArrowUp className={status}/></p>
        </div>
    )
}
const WaitTransactionSubBlock =()=>{
      return (
          <div className="sub-block">
            <br/>
            <br/>
            <FaSpinner icon="spinner" spin className = "spinner-img widgets-spinner"/>
            <br/>
          </div>
      )
  }